import React from "react";

class BlockingModal extends React.Component {

	render() {
		return (
			<div>
				<div tabIndex="-1" style={ { "display": "block"} } className="modal fade in" />
			</div>
		);
	}
}

export default BlockingModal;

/*
				<div className="modal-backdrop fade in" />
				<div tabIndex="-1" style={ { "display": "block"} } className="modal fade in" />
*/


/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/BlockingModal.jsx
 **/